import Tooltip from 'bootstrap/js/dist/tooltip';
import KeenSlider from 'keen-slider';
import Attachment from '@/javascripts/attachment';
import CommentForm from '@/javascripts/comment_form';
import ImageZoomer from '@/javascripts/components/ImageZoomer';
import { CopyTarget } from '@/javascripts/copy_target';
import ViewMode from '@/javascripts/editor/view_mode';
import '@/styles/layout/_editor.scss';
import ReplyOmitted from '@/javascripts/components/reply_omitted';
import ReplyCollapse from '@/javascripts/components/reply_collapse';
import InfiniteScroll from '@/javascripts/components/infinite_scroll';
import Mute from '@/javascripts/components/Mute';
import Mention from '@/javascripts/components/Mention';
import { mountReactComponents } from '@/utils/react_mount';
import { communityComponents } from '@/components/mountable/registry';
import type { KeenSliderInstance } from 'keen-slider';

if (!window.Coorum) {
  window.Coorum = {};
}
window.Coorum.ImageZoomer = ImageZoomer;
window.Coorum.CommentForm = CommentForm;
window.Coorum.Attachment = Attachment;
window.Coorum.Mute = Mute;
window.Coorum.Mention = Mention;

const mute = new window.Coorum.Mute();

$(() => {
  const commentRootElement = document.querySelector('.comments-content');
  const comments = document.querySelectorAll('.p-answer');

  new ReplyOmitted('.js-reply-omitted');
  new ReplyCollapse('.js-reply-collapse');

  comments.forEach((comment) => {
    mute.addToggleMuteEvent({ rootElement: comment });
  });
  addActionEvent(document);
  const imageZoomer = new window.Coorum.ImageZoomer();
  imageZoomer.setGeneralEvent();
  const editorElement = document.getElementById('editor');
  if (editorElement) {
    imageZoomer.setEditorEvent(editorElement);
  }
  new window.Coorum.CommentForm('.js-comment-form');
  document
    .querySelectorAll('.js-attachment')
    .forEach((elem) => new window.Coorum.Attachment({ spacing: 12 }, elem as HTMLElement, true));
  InfiniteScroll.init('.comments-container', '.p-answer', '.js-paginate a');
  const viewMode = new ViewMode();
  viewMode.replace();

  const answerForm = $('.answer_form');
  const mentionEl = answerForm.find('.js-mention').get(0);
  if (mentionEl && !mentionEl.closest('[data-react-mounted]')) {
    answerForm.show();
    new Mention(mentionEl as HTMLInputElement).setEvents();
  }

  $(document).on('click', '.js-answer_reply_btn', function () {
    $('.js-answer_reply_form').hide();
    const replyForm = $(`.js-answer_reply_form[data-announcement_comment-id="${$(this).data('announcement_comment-id')}"]`).show();
    const replyMentionEl = replyForm.find('.js-mention').get(0) as HTMLInputElement | undefined;
    if (replyMentionEl) {
      if (replyMentionEl.closest('[data-react-mounted]')) {
        replyMentionEl.dispatchEvent(
          new CustomEvent('mention:set-value', { detail: { value: $(this).data('user-id') as string } }),
        );
      } else {
        replyMentionEl.value = $(this).data('user-id');
        new Mention(replyMentionEl).setEvents();
      }
    }
    const headerHeight = $('.st-Header').height() || 0;
    const offsetTop = (replyForm.offset()?.top || 0) - headerHeight - 50;
    $('html, body').animate({ scrollTop: offsetTop }, 1000);
  });

  const replyWrappers = document.querySelectorAll('.sent-replies');
  const replyMutation = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node): node is Element => node.nodeType === Node.ELEMENT_NODE)
        .forEach((node) => {
          new ReplyOmitted('.js-reply-omitted', node);
        });
    });
  });
  replyWrappers.forEach((replyWrapper) => {
    replyMutation.observe(replyWrapper, { childList: true });
  });

  if (commentRootElement) {
    const commentRootMutation = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes)
          .filter((node): node is Element => node.nodeType === Node.ELEMENT_NODE)
          .forEach((node) => {
            // 追加読み込み/新規投稿されたコメント内の React いいね/リアクション/一覧モーダルをマウント
            mountReactComponents(communityComponents, node as HTMLElement);
            new window.Coorum.ImageZoomer().setGeneralEvent(node);
            const attachment = node.querySelector('.js-attachment');
            if (attachment) {
              new window.Coorum.Attachment({ spacing: 12 }, attachment, true);
            }
            mute.addToggleMuteEvent({ rootElement: node });
            addActionEvent(node);

            new ReplyOmitted('.js-reply-omitted', node);
            new ReplyCollapse('.js-reply-collapse', node);

            node.querySelectorAll('.sent-replies').forEach((replyWrapper) => {
              replyMutation.observe(replyWrapper, { childList: true });
            });

            node.querySelectorAll<HTMLElement>('oembed[url]').forEach((element) => {
              const viewMode = new ViewMode(element);
              viewMode.replace();
            });
          });
      });
      // AJAX 投稿後の prepend や infinite scroll で追加されたコメント内の返信フォームに対し、
      // CommentForm のダブルクリック / Enter 連打防止ハンドラを再 init する。
      // 初回 DOMContentLoaded 時点で DOM に存在しなかった form は登録されないため、
      // ここで再走しないと動的に追加された返信フォームの連打防御だけが効かなくなる。
      new window.Coorum.CommentForm('.js-comment-form');
    });
    commentRootMutation.observe(commentRootElement, { childList: true });
  }

  if (
    document.querySelector('.c-Slider') &&
    document.querySelector('.c-SliderController_Inner')
  ) {
    initializeSlider();
  }

  new CopyTarget().attachClickEvents('.js-ticket_copy');

  document.querySelectorAll<HTMLElement>('[data-toggle="tooltip"]').forEach((el) => {
    if (el.dataset.manualTooltipInitialized) {
      return;
    }
    el.dataset.manualTooltipInitialized = 'true';

    const tooltip = Tooltip.getOrCreateInstance(el, {
      trigger: 'manual',
      title: 'コピーしました',
      placement: 'bottom',
      container: 'body',
    });

    el.addEventListener('click', () => {
      tooltip.show();
      setTimeout(() => tooltip.hide(), 3000);
    });
  });
});

function initializeSlider() {
  const maxSize = () =>
    window.matchMedia('(max-width: 768px)').matches ? 2 : 3;
  const arrow = {
    prev: document.querySelector<HTMLElement>('[data-arrow-prev]'),
    next: document.querySelector<HTMLElement>('[data-arrow-next]'),
  };

  const slideController = (child: KeenSliderInstance, parent: KeenSliderInstance) => {
    const addActive = (idx: number) => {
      child.slides[idx].classList.add('active');
    };

    addActive(child.track.details.rel);

    child.slides.forEach((slide: HTMLElement, idx: number) => {
      slide.addEventListener('click', () => {
        if (idx !== 0) {
          child.moveToIdx(idx - 1);
        }
        parent.moveToIdx(idx);
      });
    });

    parent.on('animationStarted', (parent: KeenSliderInstance) => {
      child.slides.forEach((slide: HTMLElement) => {
        slide.classList.remove('active');
      });

      const next = parent.animator.targetIdx || 0;
      addActive(parent.track.absToRel(next));
      child.moveToIdx(Math.min(child.track.details.maxIdx, next));
    });
  };

  const updateArrows = ({
    slides: { length },
    track: {
      details: { abs },
    },
  }: KeenSliderInstance) => {
    const { prev, next } = arrow;
    prev?.setAttribute('data-disabled', 'true');
    next?.setAttribute('data-disabled', 'true');

    if (length < maxSize() + 1) return;

    if (prev) {
      abs === 0
        ? prev.setAttribute('data-disabled', 'true')
        : prev.setAttribute('data-disabled', 'false');
    }

    if (next) {
      length - maxSize() <= abs
        ? next.setAttribute('data-disabled', 'true')
        : next.setAttribute('data-disabled', 'false');
    }
  };

  const checkComplete = ({ slides }: KeenSliderInstance) => {
    slides.forEach((slide: HTMLElement) => {
      slide.style.visibility = 'visible';
    });
  };

  const slider = new KeenSlider('.c-Slider', {
    selector: '.c-Slider_Slide',
    created: (instance) => {
      checkComplete(instance);
    },
  });

  new KeenSlider('.c-SliderController_Inner', {
    selector: '.c-SliderController_Slide',
    initial: 0,
    slides: {
      perView: 'auto',
      spacing: 8,
    },
    created: (instance) => {
      checkComplete(instance);
      updateArrows(instance);
      slideController(instance, slider);
      arrow.prev?.addEventListener('click', () => instance.prev());
      arrow.next?.addEventListener('click', () => instance.next());
      window.addEventListener('resize', () => {
        updateArrows(instance);
      });
    },
    slideChanged: (instance) => {
      updateArrows(instance);
    },
  });
}

function addActionEvent(rootElement: Document | Element = document) {
  rootElement.querySelectorAll('.js-action_btn').forEach((button) => {
    button.addEventListener('click', () => {
      button.querySelector('.js-action_body')?.classList.toggle('block');
    });
  });
}
